<template>
  <v-form
    lazy-validation
    v-model="valid"
    @submit.prevent="submit"
    ref="form"
  >
      <v-container class="text-center">
        <v-text-field
          filled
          data-cy="FormBrandingCode-code"
          :label="$$t('brandingCode')"
          v-model="localBrandingCode.code"
        />
        <div class="d-flex justify-end mb-6">
          <v-btn color="default" outlined class="ml-4 btn-cancel" @click="cancel"
            data-cy="FormBrandingCode-button-cancel">
            {{ $t('common.buttons.cancel') }}
          </v-btn>
          <v-btn color="primary" type="submit" class="ml-4" :loading="isSaving"
            data-cy="FormBrandingCode-button-save">
              {{ $t('common.buttons.save') }}
            </v-btn>
        </div>
      </v-container>
  </v-form>
</template>

<script>
import loading from '@codehq/aurora-app-core/src/mixins/loading';

export default {
  name: 'FormBrandingCode',
  module: 'BrandingCode',
  mixins: [loading],
  props: {
    /**
    * Set the text box value. Default: undefined,
    */
    BrandingCode: {
      type: Object,
      default: undefined,
    },
  },
  data() {
    return {
      /**
      * Hold form validation state
      */
      valid: false,
      /**
      * Local value used for property localBrandingCode
      */
      localBrandingCode: {},
    };
  },
  watch: {
    BrandingCode() {
      this.localBrandingCode = this.BrandingCode;
    },
  },
  created() {
    this.localBrandingCode = this.BrandingCode;
  },
  methods: {
    /** Submit Form data trigger
     * @event save
     * @type {object}
     */
    submit() {
      // validate
      if (this.$refs.form.validate()) {
        this.$emit('save', this.localBrandingCode);
        this.isSaving = true;
      }
    },
    /** Cancel form trigger
     * @event cancel
     */
    cancel() {
      this.$emit('cancel');
    },
  },
};
</script>

<docs>
# FormBrandingCode example

'''js
<FormBrandingCode :BrandingCode="BrandingCode" />
'''
</docs>
